module.exports = __webpack_public_path__ + "static/media/no_logo.f9b6d6a2.png";